import {ReactElement, useState} from "react";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Title from "../../components/Title";
import {DataGridPremium, GridColDef} from "@mui/x-data-grid-premium";
import {formatSwedishDateTime} from "../../components/TimeFormat";
import {useGetFuture, useSyncFuture} from "../../application/FutureService";
import SnackbarComponent, {defaultSnackbarState, SnackbarState} from "../../components/SnackbarComponent";
import {RefreshDataFunction} from "../../components/types/RefreshDataFunction";
import {Statistics} from "../../domain/staticdata/Statistics";
import {useAutoSizeGrid} from "../../components/AutoSizeGridHook";
import {Future} from "../../domain/staticdata/Future";
import RefreshStaticComponent from "../../components/RefreshStaticComponent";

export default function Futures(): ReactElement {
    const { data, loading, apiFunction } = useGetFuture();
    const [ snackbarState, setSnackbarState ] = useState<SnackbarState>(defaultSnackbarState);
    const syncFuture: RefreshDataFunction<Statistics> = useSyncFuture();
    const apiRef = useAutoSizeGrid<Future>({
        data: data,
        loading: loading,
        columns: [
            'shortName',
            'bloombergCode',
            'name',
            'secik',
            'issuer',
            'fixDays',
            'changedTimestamp'
        ]
    })

    const initialState =
        {
            columns: {
                columnVisibilityModel: {
                },
                dimensions: {
                    shortName: { width: 250 },
                    name: { flex: 1 },
                    secik: { width: 160 },
                    issuer: { width: 100 },
                    fixDays: { width: 100 },
                    bloombergCode: { width: 200 },
                    changedTimestamp: { width: 300 }
                }
            },
            pagination: {
                paginationModel: {
                    pageSize: 500
                }
            }
        }

    const columns: GridColDef[] = [
        { field: 'shortName', headerName: 'SCD Id'},
        { field: 'bloombergCode', headerName: 'Bloomberg Code' },
        { field: 'name', headerName: 'Name', flex: 1 },
        { field: 'secik', headerName: 'Security Key' },
        { field: 'issuer', headerName: 'Issuer' },
        { field: 'fixDays', headerName: 'FixDays' },
        { field: 'changedTimestamp', headerName: 'Changed Timestamp', renderCell: (params) =>
                formatSwedishDateTime(params.row.changedTimestamp)
        }
    ];

    return (
        <Container maxWidth={ false } sx={{mt: 4, mb: 4}}>
            {<Toolbar/>}
            <Grid
                container
                spacing={2}
                sx={{
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>
                <Grid size={{ xs: 12, md: 10, lg: 10 }}>
                    <Title>Futures</Title>
                </Grid>
                <RefreshStaticComponent
                    refreshFunction={ syncFuture }
                    dataFunction={ apiFunction }
                    setSnackbarState={ setSnackbarState }
                />
            </Grid>
            <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid size={{ xs: 12, md: 12, lg: 12 }} sx={{ height: 1000 }}>
                    <DataGridPremium
                        apiRef={apiRef}
                        initialState={initialState}
                        showToolbar
                        loading={loading}
                        rows={data}
                        columns={columns}
                        density={"compact"}
                        getRowId={(row) => row.shortName}
                        pagination={true}
                        pageSizeOptions={[100,500]}
                    />
                </Grid>
            </Grid>
            <SnackbarComponent setState={ setSnackbarState} state={ snackbarState}/>
        </Container>
    );
}